export default "__VITE_ASSET__B8JlckF0__"